import apiRequest from "../../../apiRequest";
import { endPoints } from "../../../apis";

/**
 * Fetch services with optional pagination and search parameters.
 * @param {Object} params
 * @returns {Promise<any>}
 */
export const fetchServices = async (params = {}) => {
  return apiRequest.get(endPoints.GET_SERVICES, params);
};

/**
 * Create a new service.
 * @param {FormData} data
 * @returns {Promise<any>}
 */
export const createService = async (data) => {
  return apiRequest.post(endPoints.ADD_SERVICE, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * Update an existing service.
 * @param {Object} options
 * @param {number|string} options.id
 * @param {FormData} options.data
 * @returns {Promise<any>}
 */
export const updateService = async ({ id, data }) => {
  return apiRequest.put(`${endPoints.UPDATE_SERVICE}/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * Delete a service by id.
 * @param {number|string} id
 * @returns {Promise<any>}
 */
export const deleteService = async (id) => {
  return apiRequest.delete(`${endPoints.DELETE_SERVICE}/${id}`);
};

/**
 * Update service status.
 * @param {Object} options
 * @param {number|string} options.id
 * @param {"active"|"inactive"} options.status
 * @returns {Promise<any>}
 */
export const updateServiceStatus = async ({ id, status }) => {
  return apiRequest.put(`${endPoints.STATUS_SERVICE}/${id}`, { status });
};
